(function ($) {
  Drupal.behaviors.stopOtherVideos = {
    attach: function (context, settings) {
      $('.text-media-image video', context).on('play', function () {
        // Pause all other videos when a video starts playing
        $('.text-media-image video').not(this).each(function () {
          this.pause();
        });
      });
    }
  };
})(jQuery);
